import { api, setToken, getToken } from "../api.svelte.js";

let user = $state(null);
let loading = $state(true);

export function getUser() {
  return user;
}

export function isAuthenticated() {
  return !!user;
}

export function isLoading() {
  return loading;
}

export async function login(apiKey) {
  const data = await api.post("/auth/login", { api_key: apiKey });
  setToken(data.token);
  await fetchMe();
  return user;
}

export async function logout() {
  try {
    await api.post("/auth/logout");
  } catch {
    // ignore
  }
  setToken("");
  user = null;
}

export async function fetchMe() {
  if (!getToken()) {
    user = null;
    loading = false;
    return;
  }
  try {
    const data = await api.get("/auth/me");
    user = data;
  } catch {
    user = null;
    setToken("");
  }
  loading = false;
}

// Cross-tab sync
window.addEventListener("storage", (e) => {
  if (e.key === "slipstream_token") {
    if (e.newValue) {
      fetchMe();
    } else {
      user = null;
    }
  }
});

// Initialize on load
fetchMe();
